/*
 * @Author: 吴俊杰_20717 20717@etransfar.com
 * @Date: 2022-12-23 16:33:45
 * @LastEditors: 吴俊杰_20717 20717@etransfar.com
 * @LastEditTime: 2022-12-25 14:15:28
 * @FilePath: /lytMobile/src/routes/contractManage/detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import React, { Component }  from "react";
import { Toast } from "antd-mobile";
import styles from './index.less';
import { getPathParams } from "../../utils/utils";
import {getPreviewHost} from '../../utils/siteTools';
import { contractPathInfo, insertContractH5Record } from '../../services/contractManage';

export default class contractDetail extends Component {
  state = {
    getParams: getPathParams(this.props.location.search),
    contractObj: []
  }
  componentDidMount() {
    debugger
    const obj = getPathParams(this.props.location.search);
    this.setState({
      getParams: obj
    });
    this.getDeital(obj);
  }

  getDeital = item => {
    const {type, truckBrokerCompanyCode} = item;
    contractPathInfo({contractTemplateType: +type, truckBrokerCompanyCode})
    .then(res => {
      if(+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
      this.setState({
        contractObj: res.data
      });
      this.previewContract(res.data);
    });
  }

  previewContract = obj => {
    const {agreementName, version, contractCode} = obj;
    const {mobile} = this.state.getParams;
    insertContractH5Record({agreementName, version: version || contractCode, mobile})
    .then(res => {
      if(+res.code !== 0) {
        Toast.fail(res.msg);
        return;
      }
    });
  }

  render() {
    // const clientHeight = document.body.clientHeight - 45;
    const {contractObj} = this.state;
    const {agreementName, filePath} = contractObj;
    return (
      <div className={styles.contractDetailBox}>
        {filePath ? <iframe
          className={styles.embedStyle}
          title={agreementName || '合同详情'}
          ref={embed => {
              this.embed = embed;
          }}
          // style={{ height: clientHeight,  }}
          src = {`${getPreviewHost()}/onlineviewServer/onlinePreview?url=${encodeURI(contractObj.filePath)}`}
        /> : null} 
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/routes/contractManage/detail.js